<template>
  <div class="apprentice">
    <div style="position:relative;z-index:1000;background:#3A4E92;">
      <NavBtn
        :on-click="back"
      />
      <div class="nav">
        <div class="title">我的徒弟</div>
        <div class="tab">
          <div class="tab-btn" @click="tabClick(1)">按日期<div class="bottom" v-if="pageIndex == 1"></div></div>
          <div class="tab-btn" @click="tabClick(2)">按收入<div class="bottom" v-if="pageIndex == 2"></div></div>
        </div>
        </div>
    </div>
    <scroller ref='scrollersDate' v-if="pageIndex == 1" :on-infinite="infinite" noDataText=""
      >
      <div style="height:1px;"></div>
      <div>
        <div  class="member row" v-for="(member, index) in dateMembers" :key="index">
          <img :src="member.avatar" alt="">
          <span class="name">{{member.nickname}}</span>
          <span class="date">{{member.create_date}}</span>
        </div>
        <div style="height:50px;"></div>
      </div>
    </scroller>
    <scroller ref='scrollersIncome' v-if="pageIndex == 2" :on-infinite="infiniteIncome" noDataText="">
      <div style="height:1px;"></div>
      <div>
        <div  class="member row" v-for="(member, index) in incomeMembers" :key="index">
          <img :src="member.avatar" alt="">
          <span class="name">{{member.nickname}}</span>
          <span class="reward"><span>累计收益</span><span>{{member.total_income}}</span><span>元</span></span>
        </div>
        <div style="height:50px;"></div>
     </div>
   </scroller>
  </div>
</template>
<style lang='scss' scoped>
  @media only screen and (device-height: 812px) {
    .nav {
      padding-top: 64px !important;
    }
  }
  .nav {
    position: fixed;
    padding-top: 54px;
    width: 100%;
    background-color: #3A4E92;
    z-index: 10;
    top: -10px;
  }
  .apprentice {
    background-color: #3A4E92;
    height: 100%;

    ._v-container {
      padding-top: 150px;
    }

    .back {
      position: fixed;
      top: 16px;
      left: 20px;
      width: 40px;
      height: 40px;
      background: #342F74;
      box-shadow: 0 3px 5px 0 #36308E;
      border-radius: 50%;
    }

    .title {
      text-align: center;
      font-size: 18px;
      color: #FFFFFF;
      margin-bottom: 30px;

      @include regular();
    }

    .tab {
      height: 24px;
      line-height: 24px;
      text-align: center;

      .tab-btn {
        display: inline-block;
        font-size: 16px;
        color: #FFFFFF;

        @include semibold();

        .bottom {
          width: 47px;
          height: 2px;
          background: #FFFFFF;
          border-radius: 1px;
          margin: 0 auto;
        }
      }

      div:first-child {
        margin-right: 30px;
      }
    }

    .member {
      font-size: 0;
      margin: 0 auto 10px;
      padding: 0 15px;

      img {
        border-radius: 8px;
        width: 36px;
        height: 36px;
        margin-right: 10px;
        vertical-align: middle;
      }

      .name {
        font-size: 13px;
        color: #3A3A3A;
        vertical-align: middle;
        @include regular();
      }

      .date {
        font-size: 13px;
        color: #B5B5B5;
        float: right;
        vertical-align: middle;
        @include regular();
      }

      .reward {
        float: right;

        span:first-child {
          font-size: 13px;
          color: #B5B5B5;
          vertical-align: middle;
          margin-right: 5px;

          @include regular();
        }

        span:nth-child(2) {
          font-size: 18px;
          color: #3A3A3A;
          vertical-align: middle;
          margin-right: 1px;
          position: relative;
          top: -1px;

          @include roboto();
        }

        span:nth-child(3) {
          font-size: 13px;
          color: #3A3A3A;
          vertical-align: middle;

          @include semibold();
        }
      }
    }
  }
</style>
<script>
  import { mapActions } from 'vuex'
  import { URI_MEMBER_DATE, URI_MEMBER_INCOME } from '@/store/modules/account/type'
  export default {
    data () {
      return {
        pageIndex: 1,
        date_last_id: 0,
        limit: 12, // 加载的数量
        income_last_id: 0, // 数组最后一个id
        dateMembers: [], // 按日期数组
        incomeMembers: [], // 按收入数组
        noMoreDateData: false,
        noMoreIncomeData: false
      }
    },
    methods: {
      ...mapActions({
        getMemberDateList: URI_MEMBER_DATE,
        getMemberIncomeList: URI_MEMBER_INCOME
      }),
      back () {
        this.$router.push('/dashboard')
      },
      tabClick (index) {
        this.pageIndex = index
        if (index === 1) {
          this.$nextTick(() => {
            this.$refs.scrollersDate.finishInfinite(false)
          })
        } else {
          this.$nextTick(() => {
            this.$refs.scrollersIncome.finishInfinite(false)
          })
        }
        // 当数据加载到暂无更多的时候切换tab后会直接显示暂无数据
      },
      // 下拉加载
      async infinite (done) {
        // 判断有无数据 没有给默认值
        if (this.noMoreDateData) {
          done(true)
          return
        }
        let last_id = this.date_last_id
        if (this.dateMembers.length !== 0) {
          last_id = this.dateMembers[this.dateMembers.length - 1].id || 0
        } else {
          last_id = 0
        }
        let limit = this.limit
        const res = await this.getMemberDateList({
          last_id,
          limit
        })
        if (res && res.status === 200) {
          const data = res.data.payload
          this.noMoreDateData = data.length === 0 || data.length < this.limit
          this.dateMembers = this.dateMembers.concat(data)
          done(this.noMoreDateData)
        }
      },
      // 收入下拉加载数据
      async infiniteIncome (done) {
        if (this.noMoreIncomeData) {
          done(true)
          return
        }
        let limit = this.limit
        let last_income
        let last_id
        // 判断设置默认值
        if (this.incomeMembers.length !== 0) {
          last_income = this.incomeMembers[this.incomeMembers.length - 1].total_income || 0
          last_id = this.incomeMembers[this.incomeMembers.length - 1].id || 0
        } else {
          last_income = 0
          last_id = 0
        }
        const res = await this.getMemberIncomeList({
          limit,
          last_income,
          last_id
        })
        if (res && res.status === 200) {
          const data = res.data.payload
          this.noMoreIncomeData = data.length === 0 || data.length < this.limit
          this.incomeMembers = this.incomeMembers.concat(data)
          done(this.noMoreIncomeData)
        }
      }
    }
  }
</script>
